const ENumberFormat = Object.freeze({
    CURRENCY: 'currency',
    NUMBER: 'number',
    SHORT: 'short',
    PLAIN: 'plain',
    NONE: 'none'
});

export default ENumberFormat;